import { nextTick } from "vue";

// 定义每个事件对应的回调函数类型
type EventBusCallbacks = {
    "upate-nav-title": (title: string) => void
    "set-nav-right": (arg: SetNavRightArgs) => void
}

export type SetNavRightArgs = {
    title: string,
    class?: string,
    onClick: Function
    /**显示的图标样式 */
    icon?: string
}

// 提取事件名称类型
type EventBusName = keyof EventBusCallbacks;

// 定义事件总线类
class EventBus {
    // 用于存储事件及其对应的回调函数
    private events = {} as { [K in EventBusName]: Function[] };

    /* 订阅事件 */
    on<K extends EventBusName>(eventName: K, callback: EventBusCallbacks[K]) {
        if (!this.events[eventName]) {
            this.events[eventName] = []
        }
        this.events[eventName].push(callback);
    }

    /* 发布事件*/
    emit<K extends EventBusName>(eventName: K, ...args: Parameters<EventBusCallbacks[K]>) {
        const callbacks = this.events[eventName];
        if (!callbacks) return;
        callbacks.forEach((callback: Function) => {
            callback(...args);
        });
    }

    /* 取消订阅事件*/
    off<K extends EventBusName>(eventName: K, callback?: EventBusCallbacks[K]) {
        const callbacks = this.events[eventName];
        if (!callbacks) return;

        if (callback) {
            // 移除指定的回调函数
            this.events[eventName] = callbacks.filter(cb => cb !== callback) as Array<EventBusCallbacks[K]>;
        } else {
            // 移除该事件的所有回调函数
            delete this.events[eventName];
        }
    }
}

// 创建事件总线实例
const eventBus = new EventBus();

// 导出事件总线实例
export default eventBus;
